import React, { ReactNode } from "react";

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  useTheme,
} from "@mui/material";
import { RadioProps } from "@mui/material/Radio/Radio";

import { IgTypography } from "./IgTypography";
import { IgCustomTheme } from "./theme";

/**
 * @see Radio
 */

interface IgRadioProps extends RadioProps {
  description?: ReactNode;
  label?: ReactNode;
  formControlFullWidth?: boolean;
}

export const IgRadio = (props: IgRadioProps) => {
  const { description, disabled, label, formControlFullWidth, ...rest } = props;
  const theme = useTheme();

  return (
    <FormControl disabled={disabled} fullWidth={formControlFullWidth ?? false}>
      {label ? (
        <FormControlLabel
          disabled={disabled}
          control={<Radio disabled={disabled} size={"small"} {...rest} />}
          label={label}
        />
      ) : (
        <Radio disabled={disabled} size={"small"} {...rest} />
      )}

      {description && (
        <FormHelperText
          disabled={disabled}
          sx={{ marginTop: -2, marginLeft: "26px" }}
        >
          <IgTypography
            variant={"body1"}
            color={
              disabled
                ? (theme as IgCustomTheme).palette.text.interactive.neutral
                    .disabled
                : (theme as IgCustomTheme).palette.text.secondary
            }
          >
            {description}
          </IgTypography>
        </FormHelperText>
      )}
    </FormControl>
  );
};
